import axios from "axios";
import { getAuthHeaders } from "./auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

export interface ActiveReview {
  /** Tool whose cycle this review belongs to. */
  toolName: string;
  /** Cycle name, e.g. "2026Q4". */
  cycleName: string;
  /** Which stage the caller is the reviewer for (1 or 2). */
  stage: 1 | 2;
  /** ISO deadline of the active stage, or null. */
  deadline: string | null;
  /** Tool frequency, used to build the review deep link. */
  frequency: string;
}

export interface MeResponse {
  /** Lowercase UPN of the signed-in user. */
  upn: string;
  /** True if the user is a member of the AccessReviewAdmins Entra group. */
  isAdmin: boolean;
  /** Names of tools the user owns (case-insensitive UPN match on dbo.tools). */
  ownedTools: string[];
  /** Cycles where the user is the current-stage reviewer and that stage is open. */
  activeReviews: ActiveReview[];
}

export async function getMe(): Promise<MeResponse> {
  const resp = await axios.get(`${BASE_URL}/me`, { headers: getAuthHeaders() });
  return resp.data as MeResponse;
}
